<template lang="pug">
div#adicionarPvtnContainer
  pvtn-vigencia-card(
    :pvtn="pvtn"
    :isVisualizar="isVisualizar"
  )
  pvtn-municipio-card(
    v-for="(pvtnRequest, index) in pvtn.pvtnRequests"
    :pvtnRequest="pvtnRequest"
    :key="index"
    @aplicarValores="aplicarValores(pvtnRequest)"
    :isVisualizar="isVisualizar"
  )
  app-buttons-cadastro(
    :showButtonSalvar='!isVisualizar',
    :showButtonCancelar='false',
    :showButtonProximo='false',
    :showButtonFinalizar='!isVisualizar',
    :isUltimoPasso='true'
    :isPrimeiroPasso='false',
    @voltar='voltar'
    @salvar='salvar',
    @finalizar='finalizar'
  )
</template>

<script>
import { mapActions } from 'vuex'
import PvtnMunicipioCard from './components/PvtnMunicipioCard'
import PvtnVigenciaCard from './components/PvtnVigenciaCard'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import { cloneDeep } from 'lodash'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import Utils from '@/utils/utils'

export default {
  mixins: [
    AppNotificacao
  ],

  components: {
    PvtnMunicipioCard,
    PvtnVigenciaCard,
    AppButtonsCadastro
  },

  props: {
    isEdicao: {
      type: Boolean,
      required: true,
      default: false
    },
    isVisualizar: {
      type: Boolean,
      required: false,
      default: false
    },
    pvtnEdicao: {
      type: Object,
      required: false
    }
  },

  data () {
    return {
      pvtn: {
        inicio: null,
        fim: null,
        pvtnRequests: []
      }
    }
  },

  async mounted () {
    if (this.isEdicao) {
      const pvtnSalva = await this.getPvtnsByVigencia(this.pvtnEdicao.id)
      this.pvtn = {
        inicio: Utils.parseDate(pvtnSalva[0].vigencia.inicio, 'DD/MM/YYYY')._d,
        fim: Utils.parseDate(pvtnSalva[0].vigencia.fim, 'DD/MM/YYYY')._d,
        pvtnRequests: pvtnSalva.sort((a, b) => { // TODO ordenar no back
          if (a.municipio.nome < b.municipio.nome) {
            return -1
          }
          if (a.municipio.nome > b.municipio.nome) {
            return 1
          }
          return 0
        })
      }
    } else {
      const municipios = await this.getMunicipiosByEstadoAtual()

      municipios.forEach((municipio) => {
        const obj = { vtnPorHaMin: 0, vtnPorHaMed: 0, vtnPorHaMax: 0, municipio: municipio }
        this.pvtn.pvtnRequests.push(obj)
      })
    }
  },

  methods: {
    ...mapActions({
      getMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtual',
      createPvtn: 'vtn/create',
      updatePvtn: 'vtn/updatePvtn',
      getPvtnsByVigencia: 'vtn/getPvtnsByVigencia'
    }),

    voltar () {
      this.$router.push({ name: 'CONFIGURACAO_VTN' })
    },

    async salvar () {
      await this.salvarPvtn()
    },

    async finalizar () {
      await this.salvarPvtn()
      this.$router.push({ name: 'CONFIGURACAO_VTN' })
    },

    async salvarPvtn () {
      if (this.isEdicao) {
        this.pvtn.inicio = Utils.formatDate(this.pvtn.inicio, 'yyyy-MM-DD')
        this.pvtn.fim = Utils.formatDate(this.pvtn.fim, 'yyyy-MM-DD')
        await this.updatePvtn(this.pvtn)
      } else {
        await this.createPvtn(this.pvtn)
        this.isEdicao = true
        // TODO retornar pvtn criado para setar como pvtn atual em edição
      }
      this.showNotificacao(
        this.$messages.TIPO_SUCCESS,
        this.$messages.TITULO_SUCCESS,
        this.$messages.DADOS_SALVOS_SUCESSO
      )
    },

    aplicarValores (pvtnRequest) {
      this.confirmBox(this.$messages.CONFIRMAR_USO_DADOS_VTN, this.$messages.TITULO_WARNING,
        () => {
          const { vtnPorHaMin, vtnPorHaMed, vtnPorHaMax } = pvtnRequest
          const pvtnRequestsAtt = this.pvtn.pvtnRequests.map((pvtnRequestItem) => {
            pvtnRequestItem.vtnPorHaMin = vtnPorHaMin || 0
            pvtnRequestItem.vtnPorHaMed = vtnPorHaMed || 0
            pvtnRequestItem.vtnPorHaMax = vtnPorHaMax || 0

            return pvtnRequestItem
          })

          this.pvtn.pvtnRequests = cloneDeep(pvtnRequestsAtt)
        },
        () => { })
    }
  }
}
</script>

<style lang="scss" scoped>
#adicionarPvtnContainer {
  display: flex;
  gap: 3vh;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/AdicionarPvtn.vue